/**
 * Manual theme tokens are manually updated and are not generated from Figma tokens
 */

import { Convert } from '#utils/UNSAFE_typeUtils';

type Base = Convert<string, typeof base>;

const base = {
  cursor: {
    clickable: null
  },
  boxShadow: {
    xs: null,
    sm: null,
    md: null,
    lg: null,
    xl: null
  },
  borderRadius: {
    sm: null,
    md: null,
    lg: null,
    xl: null
  }
};

const animation = {
  easing: {
    enter: null,
    persist: null,
    exit: null,
    linear: null
  },
  anchor: {
    default: {
      vertical: null,
      horizontal: null
    },
    startTopCorner: {
      vertical: null,
      horizontal: null
    },
    top: {
      vertical: null,
      horizontal: null
    },
    endTopCorner: {
      vertical: null,
      horizontal: null
    },
    start: {
      vertical: null,
      horizontal: null
    },
    end: {
      vertical: null,
      horizontal: null
    },
    startBottomCorner: {
      vertical: null,
      horizontal: null
    },
    bottom: {
      vertical: null,
      horizontal: null
    },
    endBottomCorner: {
      vertical: null,
      horizontal: null
    }
  },
  duration: {
    '2xs': null,
    xs: null,
    sm: null,
    md: null,
    lg: null,
    xl: null,
    '2xl': null
  },
  delay: {
    none: null,
    sm: null,
    md: null,
    lg: null
  },
  slide: {
    up: {
      sm: null,
      md: null,
      lg: null,
      xl: null
    },
    down: {
      sm: null,
      md: null,
      lg: null,
      xl: null
    },
    start: {
      sm: null,
      md: null,
      lg: null,
      xl: null
    },
    end: {
      sm: null,
      md: null,
      lg: null,
      xl: null
    }
  },
  scale: {
    down: {
      sm: {
        to: null,
        from: null
      },
      md: {
        to: null,
        from: null
      },
      full: {
        to: null,
        from: null
      }
    },
    up: {
      sm: {
        to: null,
        from: null
      },
      md: {
        to: null,
        from: null
      },
      full: {
        to: null,
        from: null
      }
    }
  },
  fade: {
    in: {
      sm: {
        to: null,
        from: null
      },
      full: {
        to: null,
        from: null
      }
    },
    out: {
      sm: {
        to: null,
        from: null
      },
      full: {
        to: null,
        from: null
      }
    }
  }
};

const scale = {
  size: {
    units: null
  }
};

const density = {
  density: {
    units: null
  }
};

const textIcon = {
  primary: null,
  secondary: null,
  disabled: null,
  inverse: null,
  onColor: null,
  link: null,
  success: null,
  info: null,
  warning: null,
  danger: null
};

const html = {
  font: {
    family: null,
    size: null
  }
};

const body = {
  bg: {
    color: null
  }
};

const dvt = {
  label: {
    sm: {
      fontSize: null
    },
    md: {
      fontSize: null
    },
    lg: {
      fontSize: null
    }
  },
  dimmedOpacity: null
};

export type { Base };
export { scale, density, base, animation, textIcon, html, body, dvt };
